"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _BasicTestimonial = _interopRequireDefault(require("./templates/BasicTestimonial/BasicTestimonial"));
var _CardTestimonial = _interopRequireDefault(require("./templates/CardTestimonial/CardTestimonial"));
var templates = {
  BasicTestimonial: _BasicTestimonial["default"],
  CardTestimonial: _CardTestimonial["default"]
};
var Testimonial = function Testimonial(props) {
  var TemplateSelected = templates[props.template];
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('d8-c-testimonial'),
    "aria-label": props.heading || 'Heading'
  }, /*#__PURE__*/_react["default"].createElement(TemplateSelected, props));
};
Testimonial.propTypes = {
  template: _propTypes["default"].string,
  image: _propTypes["default"].string,
  heading: _propTypes["default"].string,
  text: _propTypes["default"].string,
  emoji: _propTypes["default"].string
};
Testimonial.defaultProps = {
  template: 'BasicTestimonial'
};
var _default = exports["default"] = Testimonial;